export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./myworks.vue?vue&type=template&id=5095a876&"


//////////////////
// WEBPACK FOOTER
// ./src/components/myworks.vue?vue&type=template&id=5095a876&
// module id = null
// module chunks = 